// components/MyDocumentTile/PurlDocumentCard.tsx
import { FaFilePdf, FaFolder } from "react-icons/fa6";
import { IoMdImage } from "react-icons/io";
import styles from "./index.module.css";

interface Item {
  _id?: string;
  id?: string;
  name: string;
  mimeType?: string;
  isFolder?: boolean;
  target?: string[];
  fileUrl?: string;
}

interface PurlDocumentCardProps {
  items: Item[];
  onFolderClick: (folder: Item) => void;
  onFileView: (fileId: string) => void;
  onFileDownload: (file: Item) => void;
  loading?: boolean;
}

const PurlDocumentCard = ({
  items,
  onFolderClick,
  onFileView,
  onFileDownload,
  loading,
}: PurlDocumentCardProps) => {
  const getIcon = (item: Item) => {
    if (item?.isFolder || item.target) {
      return <FaFolder className="text-gray-400 text-xl" />;
    }
    if (item?.name?.endsWith("pdf")) {
      return <FaFilePdf className="text-red-500 text-xl" />;
    }
    return <IoMdImage className="text-green-500 text-xl" />;
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center pt-20">
        <svg
          className="w-16 h-16 text-gray-200 animate-spin fill-[#55b76c]"
          viewBox="0 0 100 101"
          fill="none"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="flex justify-center items-center pt-32">
        <p className="text-gray-400">No documents found</p>
      </div>
    );
  }
  return (
    <div className="space-y-3">
      {items.map((item) => {
        const isFolder = !!item.isFolder || !!item.target;

        return (
          <div
            key={item._id || item.id}
            className="flex justify-between items-center shadow-lg border p-3 rounded hover:bg-gray-50 transition gap-2 min-h-[56px]"
          >
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="flex-shrink-0">{getIcon(item)}</div>
              <span className="text-[15px] font-medium truncate">
                {item.name}
              </span>
            </div>

            <div className="flex gap-2 flex-shrink-0">
              {isFolder ? (
                <button
                  onClick={() => onFolderClick(item)}
                  className={styles.mydocButton}
                >
                  View
                </button>
              ) : (
                <>
                  <button
                    onClick={() => onFileView(item._id!)}
                    className={`${styles.mydocButton} mr-1`}
                  >
                    View
                  </button>
                  <button
                    onClick={() => onFileDownload(item)}
                    className={styles.mydocButton}
                  >
                    Download
                  </button>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PurlDocumentCard;
